angular
    .module('annexaApp')
    .component('annexaBoxDecree',{
        templateUrl: './components/sec/annexa-box-decree/annexa-box-decree.html',
        controller:['globalModals', 'Language', 'AnnexaEntityFactory', 'ModalService', '$rootScope', 'AnnexaObjectBoxFactory', 'AnnexaFormlyFactory', 'GlobalDataFactory', '$filter', '$scope', 'AnnexaPermissionsFactory', '$state', 'SecFactory', function(globalModals, Language, AnnexaEntityFactory, ModalService, $rootScope, AnnexaObjectBoxFactory, AnnexaFormlyFactory, GlobalDataFactory, $filter, $scope, AnnexaPermissionsFactory, $state, SecFactory) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            
            vm.redirect = function (id) {
                window.open($state.href('annexa.sec.decrees.edit', { decrees: id }), '_blank');
            }
            
            vm.canShow = false;
            if(AnnexaPermissionsFactory.havePermission('view_decrees')) {
            	vm.canShow = true;
            }
            
            vm.getStatusTitle = function(decree){
            	var state = $linq(SecFactory.decreeStates).singleOrDefault(undefined, "x => x.id == 'PENDING'");
            	if(decree && decree.state){
            		state = $linq(SecFactory.decreeStates).singleOrDefault(undefined, "x => x.id == '"+decree.state+"'");
            	}
            	if(state){
            		return state.name;
            	}else{
            		return '';
            	}
            }
            
            vm.getStatusIcon = function(decree){
            	var state = $linq(SecFactory.decreeStates).singleOrDefault(undefined, "x => x.id == 'PENDING'");
            	if(decree && decree.status){
            		state = $linq(SecFactory.decreeStates).singleOrDefault(undefined, "x => x.id == '"+decree.status+"'");
            	}
            	if(state){
            		return 'fa fa-'+state.icon+' '+state.style+' fa-lg';
            	}else{
            		return '';
            	}
            }
            
        	this.$onInit = function () {
            	if(!vm.boxTitle) {
                    vm.boxTitle = 'global.sec.literals.decrees';
                }
            	vm.emptyText = 'global.sec.literals.noDecrees';
            	vm.emptyDate = 'global.sec.literals.noDecreeDate';
            	vm.emptyNumber = 'global.sec.literals.noDecreeNumber';
            }
        }],
        bindings: {
            boxTitle: '@?',
            permissions: '=',
            new: '=',
            content: '=',
            isEdit: '=',
            config: '=',
            origin: '@',
            canEdit: '='
        }
    })